import { authFetch } from "../utils/fetchWithRefresh";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const generalRequest = {
    async getShopById(shopId) {
        const res = await authFetch(`${API_BASE}/shop/${shopId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to fetch shop");
        return res.json();
    },

    async getShopWithstaffsByIdPublic(shopId) {
        const res = await authFetch(`${API_BASE}/shopwithstaffspublic/${shopId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to fetch shop");
        return res.json();
    },

    async getShopReviewsPublic(
        shopId,
        {
            limit = 10,
            cursor = null,
            sort = "newest",
        } = {}
    ) {
        const params = new URLSearchParams();
    
        if (limit) params.append("limit", limit);
        if (sort) params.append("sort", sort);
        if (cursor) params.append("cursor", cursor);
    
        const res = await authFetch(
            `${API_BASE}/shops/${shopId}/reviews?${params.toString()}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );
    
        if (!res.ok) {
            throw new Error("Failed to fetch shop reviews");
        }
    
        return res.json();
    },

    async getStaffInfoPublic(staffId) {
        const res = await authFetch(`${API_BASE}/staff/${staffId}/public`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error(await res.text());
        return res.json();
    },

    async getShop(shopId) {
        const res = await authFetch(`${API_BASE}/shops`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to fetch shop");
        return res.json();
    },

    async getServices() {
        const res = await authFetch(`${API_BASE}/services`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to fetch styles");
        return res.json();
    },

    async discover({
        city,
        province,
        category = "beauty",
        subCategory,
        sortBy,
        lat,
        lng,
        page = 1,
        limit = 20,
    } = {}) {
        const params = new URLSearchParams();

        // 📍 Location (for distance sorting)
        if (lat != null && lng != null) {
            params.append("lat", lat);
            params.append("lng", lng);
        }

        // 🔍 Filters
        if (city) params.append("city", city);
        if (province) params.append("province", province);
        if (category) params.append("category", category);
        if (subCategory) params.append("subCategory", subCategory);
        if (sortBy) params.append("sortBy", sortBy);

        // 📄 Pagination
        params.append("page", page);
        params.append("limit", limit);

        const res = await authFetch(`${API_BASE}/discover?${params.toString()}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to fetch discover shops");
        return res.json();
    },

    async searchShops(query, page = 1, limit = 20, city) {
        const params = new URLSearchParams();
        if (query) params.append("q", query);
        if (city) params.append("city", city);
        params.append("page", page);
        params.append("limit", limit);

        const res = await authFetch(`${API_BASE}/search?${params.toString()}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) throw new Error("Failed to search shops");
        return res.json();
    },

    async getShopReviews(shopId, page = 1, limit = 20) {
        const res = await authFetch(
            `${API_BASE}/shops/${shopId}/reviews?page=${page}&limit=${limit}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );

        if (!res.ok) throw new Error("Failed to fetch shop reviews");
        return res.json();
    },

    async getPublicShopsForMap(params = {}) {
        const query = new URLSearchParams(params).toString();

        const res = await authFetch(
            `${API_BASE}/shops/map${query ? `?${query}` : ""}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );

        if (!res.ok) {
            throw new Error("Failed to fetch shops for map");
        }

        return res.json();
    },

    async contactSupport({
        email,
        phone,
        subject,
        message,
    }) {
        const res = await authFetch(`${API_BASE}/support/contact`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                phone,
                subject,
                message,
            }),
        });
    
        if (!res.ok) {
            const text = await res.text();
            throw new Error(text || "Failed to send support request");
        }
    
        return res.json();
    }
};

export default generalRequest;
